import React from 'react';
import { FormGroup } from 'react-bootstrap';

const badgeStyle = {
    display: 'inline-block',
    background: '#28a745',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 'bold',
    padding: '2px 10px',
    borderRadius: '3px',
    marginBottom: '6px'
};

const messageStyle = {
    color: '#555',
    fontSize: '13px',
    margin: 0
};

// NVBDC-1403 / GAP-1403-01 — shown in place of the disability toggle + Benefit Verification
// Letter upload wherever an owner carries the SDVET designation (Renewal One-Sheet, classic
// wizard). Single source for this markup so the badge/message stay in sync across both UIs.
class SdvetNotice extends React.Component {
    render() {
        return (
            <FormGroup>
                <span style={badgeStyle}>SDVET</span>
                <p style={messageStyle}>
                    Our records indicate that your benefit verification letter is no longer
                    required. Your SDVOB status is confirmed.
                </p>
            </FormGroup>
        );
    }
}

export default SdvetNotice;



// WEBPACK FOOTER //
// ./src/areas/shared/controls/sdvetNotice/SdvetNotice.js